module.exports = __webpack_public_path__ + "static/media/payment_status_pending.12aad7c6.svg";